import { modifyState } from '~src/state';
import { toggleEditorSidebar, hideSidebarTab } from '~src/sidebarLegacy';
import { getActiveMagicFrameActive } from '~core/magicFrame';

export const handleMagicFramePhotoSelection = async (url) => {
  modifyState('magicFrameSelectPersonPhotoActive', false);
  hideSidebarTab('allegati');
  toggleEditorSidebar();
  const magicFrame = getActiveMagicFrameActive();
  if (!magicFrame) {
    return;
  }
  await magicFrame.updatePerson(url);

  magicFrame.scalePersonToCover();

  window.canvas.renderAll();
};
